export default {
  LEGAL: 'CLLE',
  CUSTOM: 'NOMI'
}
